module.exports = __webpack_public_path__ + "footer-icon-yy.png?edc7eae3d604d3ffcac629ac6fc5949f";


//////////////////
// WEBPACK FOOTER
// ./src/Footer/img/base64/footer-icon-yy.png
// module id = 19
// module chunks = 0